import {t} from '../../i18n'
import Primary from "../layouts/Primary";

import './InspectionStatus.css'
import {useContext, useState} from "react";
import DisconnectedBanner from "../components/DisconnectedBanner";
import {DisplayConfig} from "../Config";
import {
    InspectionUpdate,
} from "../../javaTypes";
import StatusLegend from "../../inspection/status/StatusLegend";
import StatusGrid from "../../inspection/status/StatusGrid";
import {usePersistentWebsocket} from "../../utils";
import DisplayParams, {DivisionInfo} from "../DisplayParams";
import EventLogo from "../components/EventLogo";

function DivisionStatusGrid({inspectionData, inspectionGroupDivision, division} : {
    inspectionData?: InspectionUpdate,
    inspectionGroupDivision: boolean,
    division?: DivisionInfo
}) {
    const columns = inspectionData ? Math.ceil(inspectionData.teams.length / (inspectionGroupDivision ? 19 : 13)) : 1;

    return <div>
        {division ? <div className="divisionHeader">
            <EventLogo logo={division.logo} /> {t`${division.name} Division`}
        </div> : null }
        <StatusGrid inspectionData={inspectionData} columns={columns} noNames={inspectionGroupDivision || columns > 3 || inspectionData && (inspectionData.forms.length > 4 && columns > 2)}/>
    </div>
}

export function InspectionStatusView({inspectionData, config} : {
    inspectionData?: InspectionUpdate,
    config: DisplayConfig
}) {
    const { isDualDivisionParent, divisions } = useContext(DisplayParams);

    let divisionOrder: number[] | undefined;
    if(config.inspectionGroupDivision && divisions) {
        divisionOrder = (config.divisionOrder || Object.keys(divisions).map(x => parseInt(x, 10)).sort((a, b) => a - b)).filter(x => divisions[x]);
    }

    const teamGroups = inspectionData ? (config.inspectionGroupDivision ? (divisionOrder?.map(d => inspectionData.teams.filter(t => t.division == d)) || []) : [inspectionData.teams]) : []

    return <Primary className={`inspectionStatus ${config.inspectionGroupDivision ? 'tiny' : ''}`} compact={config.inspectionGroupDivision}>
        <div className={"statusGridContainerWrapper"} style={{gridTemplateColumns: `repeat(${teamGroups.length}, 1fr)`}}>
            {teamGroups?.map(((tg, idx) => <DivisionStatusGrid key={idx} inspectionData={inspectionData ? {...inspectionData, teams: tg} : undefined} division={divisionOrder && divisions ? divisions[divisionOrder[idx]] : undefined} inspectionGroupDivision={config.inspectionGroupDivision} />))}
        </div>
        <StatusLegend inspectionData={inspectionData} />
    </Primary>;
}

export default function InspectionStatus({config}: { config: DisplayConfig }) {
    const params = useContext(DisplayParams)
    const [inspectionData, setInspectionData] = useState<InspectionUpdate>();
    const { isConnected, send } = usePersistentWebsocket<InspectionUpdate>(params.inspectionStatusUpdateUrl || null, (data) => {
        setInspectionData(data);
    });

    if(!params.inspectionStatusUpdateUrl) {
        return <span>{"Cannot display inspection status-missing status update url"}</span>;
    }

    return <>
        <InspectionStatusView inspectionData={inspectionData} config={config} />
        {isConnected ? null : <DisconnectedBanner />}
    </>;
}